import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

const initialState = [];

const onlineUsersSlice = createSlice({
  name: "onlineUsers",
  initialState,
  reducers: {
    userCameOnline: (state, action) => {
      const userId = String(action.payload);
      if (!state.includes(userId)) {
        state.push(userId);
      }
    },
    userWentOffline: (state, action) => {
      const userId = String(action.payload);
      return state.filter((id) => id !== userId);
    },
    resetOnlineUsers: () => []
  },
});

export const { userCameOnline, userWentOffline, resetOnlineUsers } = onlineUsersSlice.actions;
export const selectOnlineUsers = createSelector(
  (state) => state.onlineUsers,
  (onlineUserIds) => new Set(onlineUserIds)
);export default onlineUsersSlice.reducer;
